<template>
  <div>
    <el-card class="margin-top-sm">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('accountBond.queryCondition') }}</div>
      </div>
      <div class="">
        <el-form :inline="true" :model="accountBondInfo.conditions" class="flex justify-start">
          <el-form-item>
            <el-form-item>
              <el-input v-model="accountBondInfo.conditions.bondName" :placeholder="$t('accountBond.bondName')"
                clearable></el-input>
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-form-item>
              <el-select v-model="accountBondInfo.conditions.objId" :placeholder="$t('accountBond.bondType')"
                style="width:100%">
                <el-option v-for="item in accountBondInfo.shopTypes" :key="item.shopTypeId" :label="item.typeName"
                  :value="item.shopTypeId"></el-option>
              </el-select>
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="_queryAccountBondMethod()">
              {{ $t('accountBond.query') }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-card class="margin-top-sm">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('accountBond.bondInfo') }}</div>
        <el-button type="primary" size="small" @click="_openAddAccountBondModal()">
          <i class="el-icon-plus"></i>
          {{ $t('accountBond.add') }}
        </el-button>
      </div>

      <div class="">
        <el-table :data="accountBondInfo.accountBonds" border style="width: 100%">
          <el-table-column prop="bondId" :label="$t('accountBond.bondId')" align="center"></el-table-column>
          <el-table-column prop="bondName" :label="$t('accountBond.bondName')" align="center"></el-table-column>
          <el-table-column prop="amount" :label="$t('accountBond.amount')" align="center"></el-table-column>
          <el-table-column prop="bondMonth" :label="$t('accountBond.bondMonth')" align="center"></el-table-column>
          <el-table-column prop="bondName" :label="$t('accountBond.bondType')" align="center"></el-table-column>
          <el-table-column prop="remark" :label="$t('accountBond.remark')" align="center"></el-table-column>
          <el-table-column :label="$t('accountBond.operation')" align="center" width="200">
            <template slot-scope="scope">
              <el-button size="mini" @click="_openEditAccountBondModel(scope.row)">
                {{ $t('accountBond.edit') }}
              </el-button>
              <el-button size="mini" type="danger" @click="_openDeleteAccountBondModel(scope.row)">
                {{ $t('accountBond.delete') }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination @current-change="handleCurrentChange" :current-page="accountBondInfo.conditions.page"
          :page-size="accountBondInfo.conditions.row" layout="total, prev, pager, next"
          :total="accountBondInfo.total"></el-pagination>
      </div>
    </el-card>

    <add-account-bond ref="addAccountBond" @success="loadData"></add-account-bond>
    <edit-account-bond ref="editAccountBond" @success="loadData"></edit-account-bond>
    <delete-account-bond ref="deleteAccountBond" @success="loadData"></delete-account-bond>
  </div>
</template>

<script>
import { queryAccountBond, queryShopType } from '@/api/admin/accountBond/accountBondApi'
import AddAccountBond from '@/components/admin/accountBond/AddAccountBond'
import EditAccountBond from '@/components/admin/accountBond/EditAccountBond'
import DeleteAccountBond from '@/components/admin/accountBond/DeleteAccountBond'

export default {
  name: 'AccountBond',
  components: {
    AddAccountBond,
    EditAccountBond,
    DeleteAccountBond
  },
  data() {
    return {
      accountBondInfo: {
        accountBonds: [],
        total: 0,
        records: 1,
        conditions: {
          bondName: '',
          objId: '',
          page: 1,
          row: 10
        },
        shopTypes: []
      }
    }
  },
  created() {
    this._listAccountBonds(1, 10)
    this._listAddShopTypes()
  },
  methods: {
    handleCurrentChange(val) {
      this._listAccountBonds(val, this.accountBondInfo.conditions.row)
    },
    loadData() {
      this._listAccountBonds(1, 10)
    },
    async _listAccountBonds(page, rows) {
      this.accountBondInfo.conditions.page = page
      this.accountBondInfo.conditions.row = rows

      try {
        const res = await queryAccountBond(this.accountBondInfo.conditions)
        this.accountBondInfo.accountBonds = res.data
        this.accountBondInfo.total = res.total
        this.accountBondInfo.records = res.records
      } catch (error) {
        console.error('获取保证金列表失败:', error)
      }
    },
    async _listAddShopTypes() {
      try {
        const res = await queryShopType({ page: 1, row: 100 })
        this.accountBondInfo.shopTypes = res.data
      } catch (error) {
        console.error('获取店铺类型失败:', error)
      }
    },
    _openAddAccountBondModal() {
      this.$refs.addAccountBond.open()
    },
    _openEditAccountBondModel(row) {
      this.$refs.editAccountBond.open(row)
    },
    _openDeleteAccountBondModel(row) {
      this.$refs.deleteAccountBond.open(row)
    },
    _queryAccountBondMethod() {
      this._listAccountBonds(1, this.accountBondInfo.conditions.row)
    }
  }
}
</script>

<style scoped>
.ibox {
  margin-bottom: 20px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
}

.ibox-title {
  border-color: #edf1f2;
  border-style: solid solid none;
  border-width: 4px 0 0;
  color: inherit;
  margin-bottom: 0;
  padding: 14px 15px 7px;
  min-height: 48px;
}

.ibox-content {
  clear: both;
  padding: 15px;
}
</style>